import { Subject } from 'rxjs';
export const bnyTopicTenantEmitter = new Subject();
export const bnyTopicGroupEmitter = new Subject();
export const bnyTopicUserEmitter = new Subject();
